module.exports = __webpack_public_path__ + "img/main_llw.19bcfda5.jpg";